import { combineReducers } from 'redux';

import snacks from './snacks';
import formPage from './formPage';
import formData from './formData';
import { initialState as initialStateValues } from './initialState';

/* eslint-disable  */

const { snacks: _, ...emptyInitState } = initialStateValues;

const createAppReducer = (initialState) => {
  const appReducer = combineReducers({
    snacks,
    formPage,
    formData
  });

  return (state = initialState, action) => {
    const nextState = appReducer(state, action);
    if (action.error && action.payload.status === 401) {

      return {
        ...nextState,
        ...emptyInitState,
      };
    }

    return nextState;
  };
};

export default createAppReducer;
